// https://github.com/mixpanel/analytics/blob/5492c5a2727adcafc3d2ce4c5ede51d27b7357ad/go/src/mixpanel.com/arb/pb/data_groups.proto#L18
export enum DataGroupType {
  DEFAULT = 0,
  DIMENSION_TABLE = 1,
  COLOCATED = 2,
}
export interface DataGroup {
  displayName: string;
  groupID: string;
  isReady: boolean;
  propertyName: string;
  type: DataGroupType;
  properties?: TODO[];
  metadata?: Obj;
}

export interface DataGroupSelectorState {
  dataGroups: null | DataGroup[];
  fetchedDataGroups: boolean;
  selected: DataGroup;
  optionsMenuOpen: boolean;
}

export interface SelectWarning {
  dataGroupId: string;
  // whether to show a warning about switching to this group
  showWarning: boolean;
  // text to show before changing to this group (currently as a tooltip)
  warning?: string;
  // text to show after changing to this group (currently as a toast)
  changedAlert?: string;
}
